module.exports = __webpack_public_path__ + "static/media/display-1@768.adf87ebb.png";